import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { path as d3path } from 'd3-path';
import { select } from '../../utils/selection';
import { applyStyle } from '../utils';
import { angle, sub, add } from '../../utils/vector';
import { defined } from '../../utils/helper';
import { Curve } from './curve';
/**
 *
 * x9-x0---------x1-x2
 * /   |r1        |r2 \
 *x8---p0---------p1---x3
 * \ r4|          | r3 /
 *  x7-x6--------x5-x4
 */
function stroke(path, p0, p1, s0, s1) {
  var v = sub(p1, p0);
  var a = angle(v);
  var a1 = a + Math.PI / 2;
  var r1 = [s0 / 2 * Math.cos(a1), s0 / 2 * Math.sin(a1)];
  var r2 = [s1 / 2 * Math.cos(a1), s1 / 2 * Math.sin(a1)];
  var r3 = [s1 / 2 * Math.cos(a), s1 / 2 * Math.sin(a)];
  var r4 = [s0 / 2 * Math.cos(a), s0 / 2 * Math.sin(a)];
  var x0 = add(p0, r1);
  var x1 = add(p1, r2);
  var x2 = add(x1, r3);
  var x3 = add(p1, r3);
  var x4 = sub(x3, r2);
  var x5 = sub(p1, r2);
  var x6 = sub(p0, r1);
  var x7 = sub(x6, r4);
  var x8 = sub(p0, r4);
  var x9 = sub(x0, r4);
  path.moveTo.apply(path, _toConsumableArray(x0));
  path.lineTo.apply(path, _toConsumableArray(x1));
  path.arcTo.apply(path, _toConsumableArray(x2).concat(_toConsumableArray(x3), [s1 / 2]));
  path.arcTo.apply(path, _toConsumableArray(x4).concat(_toConsumableArray(x5), [s1 / 2]));
  path.lineTo.apply(path, _toConsumableArray(x6));
  path.arcTo.apply(path, _toConsumableArray(x7).concat(_toConsumableArray(x8), [s0 / 2]));
  path.arcTo.apply(path, _toConsumableArray(x9).concat(_toConsumableArray(x0), [s0 / 2]));
  path.closePath();
}
// @todo Support connect and connectStyle.
export var Trail = function Trail(options, context) {
  var document = context.document;
  return function (P, value, defaults) {
    var seriesSize = value.seriesSize,
      color = value.color;
    var defaultColor = defaults.color,
      rest = __rest(defaults, ["color"]);
    var path = d3path();
    for (var i = 0; i < P.length - 1; i++) {
      var p0 = P[i];
      var p1 = P[i + 1];
      var s0 = seriesSize[i];
      var s1 = seriesSize[i + 1];
      if ([].concat(_toConsumableArray(p0), _toConsumableArray(p1)).every(defined)) stroke(path, p0, p1, s0, s1);
    }
    return select(document.createElement('path', {})).call(applyStyle, rest).style('fill', color || defaultColor).style('d', path.toString()).call(applyStyle, options).node();
  };
};
Trail.props = Object.assign(Object.assign({}, Curve.props), {
  defaultMarker: 'line'
});